import {Pipe, PipeTransform} from '@angular/core';
import {DeliveryNoteDto} from '../../../Models/Purchases/Delivery-notes/delivery-note.interface';

@Pipe({
  name: 'deliveryNotes',
  standalone: false
})
export class DeliveryNotesPipe implements PipeTransform {

  transform(items: DeliveryNoteDto[], filter: FilterDeliveryNotePipe): DeliveryNoteDto[] {

    if (!items.length) {
      return [];
    }

    items = items.filter((item) => item.abono === (filter.isCreditNote ? 1 : 0));

    if (filter.local) {
      items = items.filter((item) => item.id_local == filter.local);
    }

    if (filter.provider) {
      items = items.filter((item) => item.id_proveedor == filter.provider);
    }

    if (filter.state) {
      items = items.filter((item) => item.id_estado == filter.state);
    }

    return items;

  }

}

export interface FilterDeliveryNotePipe {
  isCreditNote: boolean;
  local?: number;
  provider?: number;
  state?: number;
}
